import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';

const configuration = {
  type: 'longUnwidening',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'longUnwidening',
    name: 'longUnwinding',
    config: {
      candleInterval: '5 minutes',
      valuePaths: [
        // 'item0.month1Price.openInterest',
        'item0.month1Price'
      ]
    }
  },
  searchTerms: [
    'Long Unwinding'
  ],
  configFormOptions: {
    valuePathEditable: false,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.future]
  },
  buildOutputSchema: ({ name, type }) => {
    return [
      {
        name,
        type: schemaTypes.boolean,
        indicatorType: type,
        label: name,
        category: 'indicator',
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      }
    ];
  },
  isEnabled: true
};
export default configuration;
